import classNames from 'classnames';
import React from 'react';

interface PropTypes {
  fieldName?: string;
  isRequired?: boolean;
  hideRequireIndicator?: boolean;
  classNames?: string;
  fontSize?: string;
}

export function FormFieldHeader(props: PropTypes) {
  return (
    <div className={classNames('text-start mb-2', props.classNames)}>
      {props.fieldName != null && (
        <label className={classNames('d-inline', props.fontSize || 'fs-5')}>
          {props.fieldName}
        </label>
      )}
      {props.isRequired && !props.hideRequireIndicator && (
        <span className='invalid-feedback ps-1' style={{ display: 'inline' }}>
          *
        </span>
      )}
    </div>
  );
}
